<template>
  <div
    class="nav_h5"
    @click="clearOption"
    :class="{
      jp: $region === 'jp',
      en: globalLang === 'en' || globalLang === 'th' || globalLang === 'vi',
    }"
  >
    <div @click="changePage(1)" class="nav_item" :class="{ on: onItem == 1 }">
      {{ $t("service.commonProblem") }}
      <span class="hr_green"></span>
    </div>
    <div @click="changePage(2)" class="nav_item" :class="{ on: onItem == 2 }">
      {{ $t("service.myInquires") }}
      <span class="hr_green"></span>
    </div>
    <div @click="changePage(3)" class="nav_item" :class="{ on: onItem == 3 }">
      {{ $t("service.questionsRecord") }}
      <span class="hr_green"></span>
    </div>
    <div @click="changePage(4)" class="nav_item" :class="{ on: onItem == 4 }">
      {{ $t("service.contactInfo") }}
      <span class="hr_green"></span>
    </div>
        
  </div>
  
</template>

<script>
export default {
  name: "navbar",
  props: ["active"],
  components: {
  },
  data() {
    return {
      onItem: this.active || "",
      pageInfo:""
    };
  },
  methods: {
    changePage(id) {
      let urlPath = "";
      if (id == this.index) {
        // 点击当前tab，不刷新页面
        return;
      } else {
        if (id == 1) {
          // 首页不需要登陆态
          urlPath = "/service/h5";
          this.$router.push(urlPath);
        } else {
          switch (id) {
            case 2:
              urlPath = "/service/h5/question";
              break;
            case 3:
              urlPath = "/service/h5/history";
              break;
            case 4:
              urlPath = "/service/h5/info";
              break;
          }
          if (this.$area === "komoe") {
            this.$emit("changeTab", urlPath);
          } else {
            this.$router.push(urlPath);
          }
        }
      }
    },
    clearOption() {
      var kPopover = document.querySelectorAll(".k-popover");
      for (let i = 0; i < kPopover.length; i++) {
        kPopover[i] && kPopover[i].remove();
      }
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
$cl_green: #50bbe5;
$cl_dark: #444444;
.nav_h5 {
  display: flex;
  height: 0.48rem;
  padding-top: 0.12rem;
  position: fixed;
  z-index: 2;
  top: 0.48rem;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  // max-width: 540px;
  background-color: #ffffff;
  &.jp {
    .nav_item {
      font-size: 0.11rem;
    }
  }
  &.en {
    .nav_item {
      font-size: 0.11rem;
    }
  }
  .nav_item {
    flex-grow: 1;
    font-size: 0.14rem;
    text-align: center;
    color: #bdbdbd;
    line-height: 0.48rem;
    position: relative;
    border-bottom: 1px solid #eeeeee;
    &.on {
      color: $cl_dark;
      .hr_green {
        display: block;
      }
    }
    .hr_green {
      display: none;
      height: 0.04rem;
      width: 0.2rem;
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -0.1rem;
      border-radius: 0.02rem;
      background-color: $cl_green;
    }
  }
}
</style>
